import LeadForm from './LeadForm';
import * as React from 'react';
import { Modal } from '@makemydeal/dr-activities-common';

export const LeadFormModal = (props) => {
    const { isActive, elementToBlur, elementToAttachModalTo } = props;
    return (
        <Modal show={isActive} elementToAttachModalTo={elementToAttachModalTo} elementToBlur={elementToBlur}>
            <LeadForm {...props} />
        </Modal>
    );
};

export default LeadFormModal;
